import React, { useState } from 'react';
import FieldLabel from '../../../../FieldLabel';

const EntityTypeField = field => {
    const types = [
        'Individual/sole proprietor',
        'Partnership',
        'Trust/estate',
        'C Corporation',
        'S Corporation',
        'LLC C Corporation',
        'LLC S Corporation',
        'LLC Partnership',
        'Exempt payee',
    ];

    const [otherValue, setOtherValue] = useState('');

    const handlerRadioClick = value => {
        if (value !== 'other') {
            field.input.onChange(value);
            setOtherValue('');
        } else {
            field.input.onChange('other');
        }
    };

    const handlerChanges = event => {
        const val = event.target.value;
        setOtherValue(val);
        field.input.onChange(val);
    };

    const isOtherSelected = field.input.value === 'other' || (!types.includes(field.input.value) && field.input.value);

    return (
        <div className="padding-bottom-10">
            <div className={`${field.className || ''}`}>
                <div>
                    <FieldLabel
                        label={field.label}
                        className={field.labelClassName}
                        required={field.required}
                    />
                </div>

                <div className="radio_fields">
                    {types.map(typeName => (
                        <div key={typeName}>
                            <label className="wo-check-btn check_btn">
                                <input
                                    type="radio"
                                    name="entityType"
                                    value={typeName}
                                    checked={field.input.value === typeName}
                                    onChange={() => handlerRadioClick(typeName)}
                                />
                                {typeName}
                            </label>
                        </div>
                    ))}

                    <div className="no-paddings">
                        <div className="flex-box">
                            <label className="wo-check-btn check_btn">
                                <input
                                    type="radio"
                                    name="entityType"
                                    value="other"
                                    checked={isOtherSelected}
                                    onChange={() => handlerRadioClick('other')}
                                />
                                Other
                            </label>

                            {isOtherSelected && (
                                <div className="field_row" style={{ width: '100%', marginTop: '10px' }}>
                                    <div className="field_block">
                                        <textarea
                                            name="other_entity_type"
                                            placeholder="Type here"
                                            maxLength={500}
                                            value={otherValue}
                                            onChange={handlerChanges}
                                            style={{
                                                width: '100%',
                                                minHeight: '60px',
                                                padding: '8px',
                                                fontSize: '14px'
                                            }}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {field.meta.touched && field.meta.error && (
                <span className="span-error">{field.meta.error}</span>
            )}
        </div>
    );
};

export default EntityTypeField;
